module.exports = __webpack_public_path__ + "img/c4134056f83e649dd628a304c5d63343.svg";